import { TextField } from "@mui/material";
import { useState } from "react";
import { TaskCheckbox } from "../TaskCheckbox";
import { panelFontSize, PanelRow } from "./PanelSection";

// ChecklistDraftRow is a new item being typed in the middle of a checklist. Enter
// saves it and empties the field for the next one; anything else that leaves the
// field drops the draft.
export function ChecklistDraftRow(props: {
    // saving holds the field while the last title is on its way, so the next one
    // can't land ahead of it
    saving: boolean;

    onSubmit: (title: string) => void;
    onCancel: () => void;
}) {
    const [title, setTitle] = useState("");

    return (
        <PanelRow>
            <TaskCheckbox dense checked={false} disabled onChange={() => {}} />

            <TextField
                variant="standard"
                autoFocus
                fullWidth
                sx={{ flex: 1, minWidth: 0 }}
                placeholder="New item"
                value={title}
                onChange={e => setTitle(e.target.value)}
                onBlur={props.onCancel}
                onKeyDown={e => {
                    if (e.key === "Escape") {
                        e.preventDefault();
                        props.onCancel();
                        return;
                    }

                    if (e.key !== "Enter") return;
                    e.preventDefault();
                    if (props.saving) return;

                    const value = title.trim();
                    if (!value) {
                        props.onCancel();
                        return;
                    }

                    setTitle("");
                    props.onSubmit(value);
                }}
                slotProps={{
                    input: { disableUnderline: true, style: { fontSize: panelFontSize } },
                }}
            />
        </PanelRow>
    );
}
